// URLs for Stripe checkout
export const STRIPE_URLS = {
  SUCCESS_URL: `${
    process.env.REACT_APP_ORIGIN || window.location.origin
  }/success`, // Success page URL from env
  CANCEL_URL: `${process.env.REACT_APP_ORIGIN || window.location.origin}`, // Cancel page URL from env
};

export const ADOBE_EXCHANGE_URL = 'https://exchange.adobe.com/apps/cc/203997/colorcache';
